import React from 'react';
import styles from './title.module.scss';
import SVG from 'react-inlinesvg';
import { icons } from '../Icon/icons';

export interface titleProps {
  title?: string;
  MainTitle?: string;
  subTitle?: string;
  logo?: keyof typeof icons;
  style?: React.CSSProperties;
  buttonText?: string;
  linkTo?: string;
  onClick?: () => void;
}

const Title: React.FC<titleProps> = ({
  title,
  MainTitle,
  subTitle,
  logo,
  style,
  buttonText,
  onClick,
}) => {
  return (
    <div className={styles.titleWrapper} style={style}>
      {MainTitle && (
        <div className={styles.mainTitle}>
          {logo && <SVG src={icons[logo]} className={styles.logo} />}
          <h1>{MainTitle}</h1>
        </div>
      )}
      {title && (
        <div className={styles.titleContainer}>
          <h2>{title}</h2>
          {buttonText && (
            <button type='button' onClick={onClick} className={styles.addMoreButton}>
              {buttonText}
            </button>
          )}
        </div>
      )}
      {subTitle && <p className={styles.subTitle}>{subTitle}</p>}
    </div>
  );
};

export default Title;
